import { TFunction } from '@mint-lib/i18n';

import FlowCreationTab from '../features/flowTabs/FlowCreationTab.jsx';
import MainInformationTab from '../features/flowTabs/MainInformationTab.jsx';
import NotificationsTab from '../features/flowTabs/NotificationsTab.jsx';

export const getTabsList = (t: TFunction) => {
  return [
    {
      id: 'mainInfo',
      label: t('Main information'),
      a11yLabel: 'Main information tab',
      component: MainInformationTab,
    },
    {
      id: 'flowCreation',
      label: t('Flow creation'),
      a11yLabel: 'Flow creation tab',
      component: FlowCreationTab,
    },
    {
      id: 'notifications',
      label: t('Notifications'),
      a11yLabel: 'Notifications tab',
      component: NotificationsTab,
    },
  ];
};
